export class CustomerAddress {
    id:number = 0;
    name:string = '';
    street:string = '';
    colony:string = '';
    city:string = '';
    zip_code:string = '';
    locality:string = '';
    state:string = '';
    customer_id:number = 0;
    latitude:number = 0;
    longitude:number = 0;
}
